<template>
  <Modal
    v-model="_value"
    width="500"
    title="分析轨迹完成率"
    @on-visible-change="visibleChange"
    ok-text="确认处理"
    @on-ok="onOk"
    cancel-text="关闭">
    <Form  :label-width="80">
      <FormItem prop="selectDatetime">
        <DatePicker size="small" v-model="selectDatetime" placeholder="选择日期"></DatePicker>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'attentionanalysissmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      selectDatetime: null
    }
  },
  methods: {
    ...mapActions([
      'TracksIntegrityAnalysisAnalysisResultServ_AttentionAnalysis'
    ]),
    onOk () {
      console.log('onOk')
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认生成</p>',
        onOk: () => {
          if (!this.selectDatetime) {
            this.$Message.error('无效时间')
            return
          }
          let sd = new Date(this.selectDatetime).Format('yyyy-MM-dd 00:00:00')
          store.dispatch('TracksIntegrityAnalysisAnalysisResultServ_AttentionAnalysis', {
            params: { selectTime: sd }
          }).then(() => {
            this.$Message.success('修改成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.selectAnalysisDatetime = []
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
